import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import * as Rx from "rxjs/Rx";
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Injectable()
export class WebsocketService {
  constructor( protected _snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,) {}

  private subject: Rx.Subject<MessageEvent>;

  public connect(url): Rx.Subject<MessageEvent> {
      //const url = "ws://localhost:1372/"
    if (!this.subject) {
      this.subject = this.create(url);
      console.log("Successfully connected: " + url);
    }
    return this.subject;
  }

  private create(url): Rx.Subject<MessageEvent> {
    // const url = "ws://localhost:1372/"


    let ws = new WebSocket(url);
    let observable = Rx.Observable.create((obs: Rx.Observer<MessageEvent>) => {
      ws.onmessage = obs.next.bind(obs);
      ws.onerror = obs.error.bind(obs);
      ws.onclose = obs.complete.bind(obs);
      return ws.close.bind(ws);
    });
    let observer = {
      next: (data: Object) => {
        if (ws.readyState === WebSocket.OPEN) {
          this.spinner.start();
          ws.send(JSON.stringify(data));
        }
      }
    };
    return Rx.Subject.create(observer, observable);
  }
}
